import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationCommentsPluginService } from './installation-comments.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    selector: 'installation-comments-edit',
    templateUrl: './installation-comments-edit.component.html',
    standalone: false
})
export class InstallationCommentsEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  public commentToTargets: any[];
  public currentItem: any;

  private valueToRemove: number;
  private sub = new Subscription();

  @ViewChild('commentToTargetsModal', { static: true }) commentToTargetsModal: ModalComponent;
  @ViewChild('valueDeleteConfirm', { static: true }) valueDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected cdRef: ChangeDetectorRef,
    location: Location,
    protected pluginService: InstallationCommentsPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['comments'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateComments(this.inspectionId, this.pointId, this.pluginId, model.comments)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    control.push(this.initArrayValue());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    control.removeAt(this.valueToRemove);
  }

  public onClose(e: any) {
    this.currentItem.controls['To'].markAsTouched();
  }

  public selectCommentToTargetsMenu(item: any) {
    const selectedIndex = this.currentItem.controls['To'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['To'].setValue(selectedIndex);
  }

  public openToSelector(selectedIndex: number, i: number): void {
    this.openSelector(
      this.commentToTargetsModal,
      this.commentToTargets,
      selectedIndex || selectedIndex === 0 ? selectedIndex : -1
    );
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    this.currentItem = control.controls[i];
  }

  openValueDeleteConfirm(i: number) {
    this.valueDeleteConfirm.open();
    this.valueToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.commentToTargets = _.orderBy(this.pluginService.getCommentToTargets(), ['label']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      comments: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    _.forEach(this.plugin.config.Comments, (el) => {
      control.push(this.initArrayValue(el));
    });
  }

  private initArrayValue(el?: any) {
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    return this.fb.group({
      To: new UntypedFormControl(el && el.To ? parseInt(el.To) : 0),
      Comment: new UntypedFormControl(el?.Comment ? el.Comment.replace(regex, '\n') : '')
    });
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '20rem',
    minHeight: '5rem',
    width: '100%',
    placeholder: 'Insert your comments here',
    translate: 'no',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'heading',
        'fontName',
        'fontSize',
        'textColor',
        'backgroundColor',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };
}
